import { createReduxAsyncAction } from '../utils/toolkit';
import { TYPES } from './constants';

export const loadEvent = createReduxAsyncAction(TYPES.LOAD_EVENT);
export const loadEventWithFilters = createReduxAsyncAction(TYPES.LOAD_EVENT_WITH_FILTERS);
export const getIdEvent = createReduxAsyncAction(TYPES.GET_ID_EVENT);
export const saveEvent = createReduxAsyncAction(TYPES.SAVE_EVENT);
export const deleteEvent = createReduxAsyncAction(TYPES.DELETE_EVENT);
export const setInviteEvent = createReduxAsyncAction(TYPES.SET_INVITE_EVENT);
export const eventDeclineLinemen = createReduxAsyncAction(TYPES.EVENT_DECLINE_LINEMEN);
export const updateEventStatus = createReduxAsyncAction(TYPES.UPDATE_EVENT_STATUS);
